// extracted by mini-css-extract-plugin
module.exports =  {"counter":"_32bbee5fda--counter--vvT47"};